export default __webpack_public_path__ + "static/media/Payment.90c4b8c8.png";